import React from 'react'
import { useSelector } from 'react-redux'
import { selectFavouriteModes, selectPreferredMode } from '../../store/travelOptions/travelOptions.selectors'
import { setPreferredMode } from '../../store/travelOptions/travelOptions.actions'
import ModeItem from '../itinerary/ModeItem'
import sModeSelector from '../itinerary/ModeSelector.less'
import { useAction } from '../utils/react-redux'
import { dispatchTag } from '../../store/analytics/analytics.actions'
import { TAG_CLICK_TRAVEL_OPTIONS_MODEFAVORI } from '../../store/analytics/analytics.actionTypes'
import { SELECTION } from '../analytics/ClickTagsService'

const FavouriteModeBox = () => {
  const favouriteModes = useSelector(selectFavouriteModes)
  const preferredMode = useSelector(selectPreferredMode)
  const execSetPreferredMode = useAction(setPreferredMode)
  const execDispatchTag = useAction(dispatchTag)

  const onClickForId = id => () => {
    execDispatchTag({
      type: TAG_CLICK_TRAVEL_OPTIONS_MODEFAVORI,
      tagInfo: {
        [SELECTION]: id
      }
    })
    execSetPreferredMode({ modeId: id })
  }

  return (
    <ul>
      {favouriteModes.map(({ id, label, icon }) => {
        return (
          <li className={sModeSelector.listItemFavorites} key={id}>
            <ModeItem
              selected={preferredMode === id}
              icon={icon}
              description={label}
              onClick={onClickForId(id)}
              displayHighlightBar={false}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default FavouriteModeBox
